exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thanks{display:block;width:800px;min-height:200px;margin:61px auto 0}.thanks .header{min-height:0;margin:38px auto 0;padding:17px 18px 17px 0;color:#fff;font-size:48px;font-weight:400;border-radius:4px;background-color:#803a78;line-height:44px}.thanks .content{margin:14px 0;padding:21px 38px 35px;border:1px solid #d8d8d8;border-radius:4px;background-color:#f3f3f3}.thanks .content .thanks-title{margin-bottom:30px;color:#803a78;font-size:32px;font-weight:400}.thanks .content .paragraph-3{margin-top:10px;margin-bottom:35px;padding-top:0;border-top:1px none #dadada;border-bottom:1px none #000;color:#3a7280;font-size:20px;line-height:25px}.thanks .content .paragraph-3 .bold-text-5{font-weight:400}.thanks .content .line{height:2px;border-radius:4px;background-color:#995191;text-align:center;text-decoration:none}.thanks .content .line .fa{position:relative;bottom:13px;color:#803a78;font-size:26px;line-height:30px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/thanks/thanks.scss
// module id = 531
// module chunks = 0